import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import type { ChestRewardMPNotification } from '@swf/core/types/Notification';
import { encodeQuery } from '@swf/core/utils';

export const launchCOW = ({ attributes, history }: ActionParams) =>
  history.push({
    pathname: '/account/open-chest',
    search: encodeQuery({
      chest: (attributes as ChestRewardMPNotification['attributes']).chestId
    })
  });

export const launchICEChallenge = ({ attributes, history }: ActionParams) => {
  const { icePromoId } = attributes as ChestRewardMPNotification['attributes'];
  const path = icePromoId ? `/${icePromoId}` : '';
  history.push(`/account/ice/challenges${path}`);
};
